export const environment = {
    production: false,
    apiUrl: '',

    auth0: {
        domain: 'login-stg.transnetyx.com',
        clientId: '',
        redirectUri: '${window.location.origin}',
        logoutReturnUrl: `https://accounts-stg.transnetyx.com/v2/logout/sequencing`,
        logoutUrl: 'https://login-stg.transnetyx.com/v2/logout',
    },

    analytics: {
        enable: true,
        mixpanelCode: '',
    },

    colonyUrl: 'https://colony-stg.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-stg.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-stg.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-stg.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-stg.transnetyx.com/MVC/Account/Register',
    quickorderSettingsUrl: 'https://quickorder-stg.transnetyx.com/Account.aspx',
    quickorderPaymentSettingsUrl: 'https://quickorder-stg.transnetyx.com/PaymentMethods.aspx',
    quickorderMessagesUrl: 'https://quickorder-stg.transnetyx.com/Messages.aspx',
    ordersUrl: 'https://quickorder-stg.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder-stg.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder-stg.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder-stg.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts-stg.transnetyx.com/Account/Details',
    accountRegisterUrl: 'https://accounts-stg.transnetyx.com/register/quick-order',
    billingSettingsUrl: 'https://quickorder-stg.transnetyx.com/PaymentMethods.aspx',
    messageSettingsUrl: 'https://quickorder-stg.transnetyx.com/EmailPreferences.aspx',
    tissueUrl: 'https://tissue.transnetyx.com/',
    checkMateUrl: 'https://checkmate.transnetyx.com/',
    registerUrl: 'https://login-stg.transnetyx.com/authorize',
};
